export default {"src":"/_next/static/media/care-team-at-work-functional.colour.9ccec5af.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};